var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"label"},[_c('div',{class:['label', { colorBoolean: _vm.colorBoolean }]},[_vm._v(" "+_vm._s(_vm.item[_vm.column.name])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }